module.exports = __webpack_public_path__ + "img/withdraw-record.af819bab.svg";